<template>
<div>
    <smallbutton :toplabel="title" @click="Show()" v-if="showButton" :disabled="disabled" :buttonclass="buttonclass"/>
    <linkbutton :toplabel="title" @click="Show()" v-if="showLink" :disabled="disabled"/>
    <removebutton @click="Show()" v-if="showImageButton" :disabled="disabled"/>

    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <label class="titlelabel">{{title}}</label>
            <label >{{body}}</label>
            <div>
                <smallbutton  @click="CloseWithYes" toplabel="Yes"/>
                <smallbutton  @click="CloseWithNo" toplabel="No"/>
            </div>
            <div>
              <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import linkbutton from '../controls/linkbutton.vue'
import removebutton from '../controls/removebutton.vue'
export default {
    name:'confirm',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
        removebutton
    },
    props:{
        title:{
            type:String,
            required:true
        },
        body:{
            type:String,
        },
        showButton:{
            type:Boolean,
            default:false
        },
        showImageButton:{
            type:Boolean,
            default:false,
        },
        showLink:{
            type:Boolean,
            default:false
        },
        disabled:{
          type:Boolean,
          default:false
        },
        buttonclass:{
            type:String,
            default:"button primarybutton"
        }
    },
    data(){
        return{
            responseMessage:''
        }
    },
    methods:{
        Show(){
            this.$refs.mymodal.openModal()
        },
        async CloseWithYes(){
            this.$emit('yes')
            this.$refs.mymodal.closeModal()
        },
        async CloseWithNo(){
            this.$emit('no')
            this.$refs.mymodal.closeModal()
        }
    }
}
</script>

<style>

</style>